export default ({programId, amount, senderEmail, recipientEmail, cardDesignId, promoCode, locale, action, accountId}) => {
  return {
    programId,
    amount,
    purchaserEmail: senderEmail,
    recipientEmail,
    cardDesignId,
    promoCode,
    locale,
    action,
    accountId
  };
};
